exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pii-popup-container {\r\n    max-height: 480px;\r\n    overflow-y: scroll;\r\n    overflow-x: hidden;\r\n    background-color: #F0F0F0;\r\n}\r\n.pii-popup-header {\r\n    height: 45px;\r\n    padding-top: 10px;\r\n}\r\n.pii-popup-carousel {    \r\n    height: 660px;\r\n    border: 1px solid #D9D9D9;\r\n    background: #D9D9D9;\r\n}\r\n.pii-carousel, .pii-slide {\r\n    max-width: 960px !important;\r\n    max-height: 640px !important;\r\n}\r\n.pii-popup-table {    \r\n    margin-left: -22px;\r\n    margin-right: -22px;\r\n    height: 440px;\r\n}\r\n.pii-print-icon {\r\n    width: 20px;\r\n    margin-right: 3px;\r\n}\r\n.pii-print-label {\r\n    color: #12408B;\r\n    margin-right: 45px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/inventory/asrs/pallet-image-home/pallet-image-popup/pallet-image-popup.component.css
// module id = ../../../../../src/app/features/inventory/asrs/pallet-image-home/pallet-image-popup/pallet-image-popup.component.css
// module chunks = main